import { INTEGRATION_TYPES } from '@vy/integrations-types';
import { useConnectedIntegrations } from './use-integrations';

export const useIsTaxIntegrationsConnected = () => {
  const { data: connectedIntegrations } = useConnectedIntegrations();

  return connectedIntegrations?.includes(INTEGRATION_TYPES.ANROK);
};
